import { createContext } from 'react';
import { AuthContextType } from '../../types/index'

export const AuthContext = createContext<AuthContextType | null>(null);
